module.exports = __webpack_public_path__ + "img/low.eacb9605.png";